import { useEffect, useState } from 'react';
import { getListItems } from '../services/api';

export function useContentList(loadFn, deps = []) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    async function load() {
      try {
        setLoading(true);
        const response = await loadFn();
        if (active) {
          setItems(getListItems(response));
          setError(null);
        }
      } catch (err) {
        if (active) {
          setError(err.message);
          setItems([]);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { items, loading, error };
}

export function useContentItem(loadFn, id) {
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) {
      setLoading(false);
      setItem(null);
      return undefined;
    }

    let active = true;

    async function load() {
      try {
        setLoading(true);
        const response = await loadFn(id);
        if (active) {
          setItem(response.data);
          setError(null);
        }
      } catch (err) {
        if (active) {
          setError(err.message);
          setItem(null);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return { item, loading, error };
}
